<fieldset>
  <rs-tabs
    #staticTabs
    (getActiveTab)="changeElement($event)"
    css="rs-tabs">
    @for (control of controlsArray; track control; let i = $index) {
      <rs-tab [tabTitle]="control.elementOptions.label | translate">
        <div class="form-group">
          @if (i === index) {
            <ng-container rsResolve [element]="control"></ng-container>
          }
        </div>
      </rs-tab>
    }
  </rs-tabs>
</fieldset>